import { EnergyType } from '../EnergyFlow'
import { LocalGridProvider } from './common/LocalGridProvider'

/**
 * Fully provides for the heating/cooling demand and requests the same amount
 * of energy from the local water grid.
 */
export class LocalWaterGridProvider extends LocalGridProvider {
  public readonly providedEnergyTypes = [EnergyType.Heating, EnergyType.Cooling]
}
